import { findResourcesList } from "@/api/configInfo";

export function getResourceList(bizType) {
  return findResourcesList(bizType)
    .then(res => {
      const { data = [] } = res;
      return data;
    })
    .catch(_ => _);
}
